export const TOUR_COMPLETED_EVENT = "rbTourCompleted";

const tourKey = (userId, key) => `${key}_${userId}`;

const LEGACY_KEYS = ["hasSeenTour", "giveProfileChance"];

const removeLegacyTourKeys = () => {
  LEGACY_KEYS.forEach((key) => localStorage.removeItem(key));
};

export const getHasSeenTour = (userId) => {
  if (userId) {
    const perUserValue = localStorage.getItem(tourKey(userId, "hasSeenTour"));
    if (perUserValue !== null) {
      return perUserValue;
    }
  }

  return localStorage.getItem("hasSeenTour");
};

export const setHasSeenTour = (userId, seen) => {
  const value = seen ? "true" : "false";

  if (userId) {
    localStorage.setItem(tourKey(userId, "hasSeenTour"), value);
    removeLegacyTourKeys();
    return;
  }

  localStorage.setItem("hasSeenTour", value);
};

export const getGiveProfileChance = (userId) => {
  if (userId) {
    const perUserValue = localStorage.getItem(
      tourKey(userId, "giveProfileChance")
    );
    if (perUserValue !== null) {
      return perUserValue;
    }
  }

  return localStorage.getItem("giveProfileChance");
};

export const setGiveProfileChance = (userId, enabled) => {
  const value = enabled ? "true" : "false";

  if (userId) {
    localStorage.setItem(tourKey(userId, "giveProfileChance"), value);
    removeLegacyTourKeys();
    return;
  }

  localStorage.setItem("giveProfileChance", value);
};

export const initTourStateForUser = (
  userId,
  { isNewSignup = false, isHome = true } = {}
) => {
  if (!userId) {
    return;
  }

  if (localStorage.getItem(tourKey(userId, "hasSeenTour")) !== null) {
    return;
  }

  if (isNewSignup) {
    setHasSeenTour(userId, false);
    setGiveProfileChance(userId, true);
    return;
  }

  setHasSeenTour(userId, !isHome);
  setGiveProfileChance(userId, false);
};

export const clearTourStateForUser = (userId) => {
  if (!userId) {
    return;
  }

  localStorage.removeItem(tourKey(userId, "hasSeenTour"));
  localStorage.removeItem(tourKey(userId, "giveProfileChance"));
};
